import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../Context/GlobalContext";
import useClients from "../ClientServices/useClient";
/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useBilling() {
  const {fetchAll}=useClients();

  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));

  
const getUserBillingData = async (userid) => {
  try {
    const res = await api.post(
      "/Admin/v1.0/getUserBillingData",
      { userid: String(userid) }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data.response || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to fetch clients",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getUserBillingData error:",
      e
    );
    return {
      success: false,
      message: "Error fetching clients",
      data: [],
    };
  }
};
const getParentWallet = async ({
  userid,
  secret = "string",
}) => {
  try {
    const res = await api.post(
      "/Whatsapp/v1.0/getParentWallet",
      { userid, secret }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: Number(
          res?.data?.data?.wl_balance || 0
        ),
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load wallet",
        data: 0,
      };
    }
  } catch (e) {
    console.error(
      "getParentWallet error:",
      e
    );
    return {
      success: false,
      message: "Failed to load wallet",
      data: 0,
    };
  }
};

const getBillingInsights = async ({
  userid,
  interval,
  secret = "string",
}) => {
  try {
    const res = await api.post(
      "/Admin/v1.0/getBillingData",
      { userid, interval, secret }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data?.data || {},
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to fetch billing data",
        data: {},
      };
    }
  } catch (e) {
    console.error(
      "getBillingData error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to fetch billing data",
      data: {},
    };
  }
};

const getWhatsappBillingData = async ({
  userid,
  interval,
  secret = "string",
}) => {
  try {
    const res = await api.post(
      "/Whatsapp/v1/getBillingData",
      { userid, interval, secret }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data?.data || {},
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load billing data",
        data: {},
      };
    }
  } catch (e) {
    console.error(
      "getWhatsappBillingData error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to load billing data",
      data: {},
    };
  }
};
const getWhatsappBillingLedger = async ({
  userid,
  interval,
  secret = "string",
}) => {
  try {
    const res = await api.post(
      "/Whatsapp/getBillingLedger",
      { userid, interval, secret }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data?.data || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load ledger",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getWhatsappBillingLedger error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to load ledger",
      data: [],
    };
  }
};

const getCampaignsSimple = async ({
  userid,
  campaignName = "string",
}) => {
  try {
    const res = await api.post(
      "/Campaign/getCampaigns",
      { userid, campaignName }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data?.data || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to load campaigns",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getCampaignsSimple error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to load campaigns",
      data: [],
    };
  }
};
const getTemplateInsights = async ({
  userid,
  templateId,
  secret = "string",
}) => {
  try {
    const res = await api.post(
      "/Admin/v1.0/getTemplateInsights",
      { userid, templateId, secret }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data?.data || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to fetch template insights",
        data: [],
      };
    }
  } catch (e) {
    console.error(
      "getTemplateInsights error:",
      e
    );
    return {
      success: false,
      message:
        "Failed to fetch template insights",
      data: [],
    };
  }
};


  useEffect(() => {
    if(adminId){

      fetchAll(); 
    }
  }, [adminId]);

  return {
    clients,
    orders,
    loading,
    busy,
    getUserBillingData,
    getParentWallet,
    getBillingInsights,
    getWhatsappBillingData,
    getWhatsappBillingLedger,
    getCampaignsSimple,
    getTemplateInsights,
    


  };
}